<template>
    <label :class="{ 'checked': isChecked }">
        <span>&nbsp;</span>
        <span>&nbsp;</span>
        <input type="checkbox" :name="name" :value="value" v-model="isChecked" @click="change" />
        <span class="check"></span>
        <span>&nbsp;</span>
        <span>&nbsp;</span>
        <span>&nbsp;</span>
        <span class="text">
            <span>{{ $t(value)}}</span>
          </span>
        <span>&nbsp;</span>
        <span>&nbsp;</span>
    </label>
</template>

<script>
    import {EventBus} from '../../services/eventBus'

    export default {
        name: "checkbox",
        props: {
            name: String,
            value: String,
            group: String,
            filtergroup: String,
            checked: Boolean,
            filterId: String
        },
        data () {
            return {
                isChecked: false,
            }
        },
      methods: {
        change() {
          let filter = {filtergroup: this.filtergroup, group:this.group, value: this.value, checked: !this.isChecked, filterId:this.filterId}
          EventBus.$emit('setFilter', filter)
        }
      },
      mounted () {
          this.isChecked = this.checked
      }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/elements/SquareCheckbox.vue